import React from 'react';
import { Box, Typography, useTheme } from '@mui/material';
import { SmartToy as SmartToyIcon } from '@mui/icons-material';

const IntroAnimation = ({ bot, showAnimation }) => {
  const theme = useTheme();
  
  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0,0,0,0.85)',
        zIndex: 9999,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        opacity: showAnimation ? 1 : 0,
        visibility: showAnimation ? 'visible' : 'hidden',
        transition: 'opacity 0.8s ease-in-out, visibility 0.8s ease-in-out',
      }}
    >
      <Box
        sx={{
          position: 'relative',
          width: 200,
          height: 200,
        }}
      >
        {/* Robot icon with pulsing effect */}
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 120,
            height: 120,
            borderRadius: '50%',
            backgroundColor: bot?.customizations?.primaryColor || theme.palette.primary.main,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            animation: 'pulse 1.5s infinite ease-in-out',
          }}
        >
          <SmartToyIcon sx={{ fontSize: 80, color: 'white' }} />
        </Box>
        
        {/* Orbiting circle */}
        <Box
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            borderRadius: '50%',
            border: '2px dashed rgba(255,255,255,0.3)',
            animation: 'spin 8s linear infinite',
          }}
        >
          <Box
            sx={{
              position: 'absolute',
              top: 0,
              left: '50%',
              width: 20,
              height: 20,
              backgroundColor: '#fff',
              borderRadius: '50%',
              transform: 'translateX(-50%)',
            }}
          />
        </Box>
      </Box>
      
      <Typography 
        variant="h4" 
        sx={{ 
          color: 'white', 
          mt: 4, 
          fontWeight: 'bold',
          textAlign: 'center',
          animation: 'fadeInUp 1s ease-out'
        }}
      >
        Welcome to {bot?.name || 'AI Assistant'} Demo
      </Typography>
      
      <Typography 
        variant="body1" 
        sx={{ 
          color: 'rgba(255,255,255,0.7)', 
          mt: 2,
          maxWidth: 600,
          textAlign: 'center',
          animation: 'fadeInUp 1s ease-out 0.3s both'
        }}
      >
        This demo shows how your AI chatbot will appear and function on your website. 
        Try asking questions to see how it responds!
      </Typography>
    </Box>
  );
};

export default IntroAnimation;
